interface TabsProps<T> {
  tabs: {
    key: T
    title: string
    badge?: string | number
  }[]
  selectedTab: T
  setSelectedTab: (tab: T) => void
  className?: string
}

export function Tabs<T>({
  tabs,
  selectedTab,
  setSelectedTab,
  className = '',
}: TabsProps<T>) {
  return (
    <div className={`flex w-full ${className}`}>
      {tabs.map(({ key, title, badge }) => {
        const isActive = selectedTab === key
        return (
          <button
            type="button"
            key={String(key)}
            onClick={() => setSelectedTab(key)}
            className={`
              flex-1 text-base p-2 sm:p-3 text-center relative
              transition-colors duration-200
              ${
                isActive
                  ? 'text-[#191D23] font-semibold border-b-2 border-green-700'
                  : 'text-[#191D23] font-light hover:text-[#191D23]'
              }
            `}
          >
            <span className="inline-flex items-center gap-2">
              {title}
              {badge !== undefined && (
                <span
                  className={`inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium rounded-full ${
                    isActive
                      ? 'bg-green-100 text-green-800'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {badge}
                </span>
              )}
            </span>
          </button>
        )
      })}
    </div>
  )
}
